import { render, staticRenderFns } from "./HMSelectStudentModal.vue?vue&type=template&id=3afd8765&scoped=true&"
import script from "./HMSelectStudentModal.vue?vue&type=script&lang=js&"
export * from "./HMSelectStudentModal.vue?vue&type=script&lang=js&"
import style0 from "./HMSelectStudentModal.vue?vue&type=style&index=0&id=3afd8765&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afd8765",
  null
  
)

export default component.exports